import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDPressKitSceneController {
    private readonly sidebarController: UISidebarController
    private readonly pressKitSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.pressKitSceneContainerDiv = document.getElementById('scene_discord_press_kit_container') as HTMLDivElement
    }

    hide() {
        this.pressKitSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.pressKitSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
